import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Rolingimg/icon_zjt_.png'
import _imports_1 from '@/assets/Rolingimg/icon_yyjt_.png'
import _imports_2 from '@/assets/Rolingimg/icon_xjt_2.png'


const _withScopeId = n => (_pushScopeId("data-v-d98da642"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Rollong" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  ref: "routerList",
  class: "routerList"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 1024 1024",
  width: "15px",
  height: "15px",
  xmlns: "http://www.w3.org/2000/svg",
  "data-v-78e17ca8": ""
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"
  })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "border_right",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScrollLeft && _ctx.handleScrollLeft(...args)))
      }, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currRoute, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass({ isActive: item.path == _ctx.router.currentRoute.value.fullPath }),
            key: index
          }, [
            _createVNode(_component_router_link, {
              to: item.path
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name == "Home" ? "首页" : item.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]),
            (item.name != 'Home')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "delectRouter",
                  onClick: ($event: any) => (_ctx.delectRouter(index, item))
                }, _hoisted_7, 8, _hoisted_5))
              : _createCommentVNode("", true)
          ], 2))
        }), 128))
      ], 512),
      _createElementVNode("div", {
        class: "border_right",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleScrollRight && _ctx.handleScrollRight(...args)))
      }, _hoisted_9)
    ]),
    _createElementVNode("div", {
      class: "border_right routerTab",
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.routerTab && _ctx.routerTab(...args)))
    }, [
      _createElementVNode("img", {
        class: _normalizeClass({ isImage: _ctx.routeDisplay }),
        src: _imports_2,
        alt: ""
      }, null, 2),
      (_ctx.routeDisplay)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("span", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.currRouter && _ctx.currRouter(...args)))
            }, "关闭当前标签页"),
            _createElementVNode("span", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.otherRouter && _ctx.otherRouter(...args)))
            }, "关闭其他标签页"),
            _createElementVNode("span", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.AllRouter && _ctx.AllRouter(...args)))
            }, "关闭全部标签页")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}